
export const labels = {
  "type": "FeatureCollection",
  "name": "Buurten_labels",
  "crs": {
      "type": "name",
      "properties": {
          "name": "urn:ogc:def:crs:OGC:1.3:CRS84"
      }
  },
  "features": [
      {
          "type": "Feature",
          "properties": {
              "buurtcode": "BU03450000",
              "buurtnaam": "Koopcentrum",
              "brtnaam_gemeente": "Koopcentrum",
              "Fasering": "Lange termijn wijk"
          },
          "geometry": {
              "type": "Point",
              "coordinates": [
                  5.556149499999998,
                  52.027024499999996
              ]
          }
      },
      {
          "type": "Feature",
          "properties": {
              "buurtcode": "BU03450001",
              "buurtnaam": "Vijgendam en omgeving",
              "brtnaam_gemeente": "Meesterweide",
              "Fasering": "Middellange termijn wijk"
          },
          "geometry": {
              "type": "Point",
              "coordinates": [
                  5.562471558667976,
                  52.028974165263776
              ]
          }
      },
      {
          "type": "Feature",
          "properties": {
              "buurtcode": "BU03450002",
              "buurtnaam": "Schrijverswijk",
              "brtnaam_gemeente": "Schrijverswijk",
              "Fasering": "Middellange termijn wijk"
          },
          "geometry": {
              "type": "Point",
              "coordinates": [
                  5.5604845385565485,
                  52.02541624278104
              ]
          }
      },
      {
          "type": "Feature",
          "properties": {
              "buurtcode": "BU03450003",
              "buurtnaam": "Beatrixstraat en omgeving",
              "brtnaam_gemeente": "Achterkerk",
              "Fasering": "Lange termijn wijk"
          },
          "geometry": {
              "type": "Point",
              "coordinates": [
                  5.552188465249274,
                  52.026656948759644
              ]
          }
      },
      {
          "type": "Feature",
          "properties": {
              "buurtcode": "BU03450100",
              "buurtnaam": "Dragonder-Noord",
              "brtnaam_gemeente": "Dragonder-Noord",
              "Fasering": "Middellange termijn wijk"
          },
          "geometry": {
              "type": "Point",
              "coordinates": [
                  5.569039640390828,
                  52.03236617077601
              ]
          }
      },
      {
          "type": "Feature",
          "properties": {
              "buurtcode": "BU03450101",
              "buurtnaam": "Dragonder-Zuid",
              "brtnaam_gemeente": "Dragonder-Zuid",
              "Fasering": "Verkenningswijk"
          },
          "geometry": {
              "type": "Point",
              "coordinates": [
                  5.568127159641022,
                  52.02535322397886
              ]
          }
      },
      {
          "type": "Feature",
          "properties": {
              "buurtcode": "BU03450102",
              "buurtnaam": "De Compagnie-Oost",
              "brtnaam_gemeente": "De Compagnie-Oost",
              "Fasering": "Bedrijventerrein"
          },
          "geometry": {
              "type": "Point",
              "coordinates": [
                  5.576348892309611,
                  52.03669783573095
              ]
          }
      },
      {
          "type": "Feature",
          "properties": {
              "buurtcode": "BU03450103",
              "buurtnaam": "Spitsbergen",
              "brtnaam_gemeente": "Spitsbergen",
              "Fasering": "Natuurlijk tempo (individuele oplossing)"
          },
          "geometry": {
              "type": "Point",
              "coordinates": [
                  5.577494258646161,
                  52.030701340169436
              ]
          }
      },
      {
          "type": "Feature",
          "properties": {
              "buurtcode": "BU03450104",
              "buurtnaam": "Dragonder-Oost",
              "brtnaam_gemeente": "Dragonder-Oost",
              "Fasering": "Verkenningswijk"
          },
          "geometry": {
              "type": "Point",
              "coordinates": [
                  5.5756152018216545,
                  52.023781538022064
              ]
          }
      },
      {
          "type": "Feature",
          "properties": {
              "buurtcode": "BU03450105",
              "buurtnaam": "Veenendaal-Oost",
              "brtnaam_gemeente": "Veenderij",
              "Fasering": "Verkenningswijk"
          },
          "geometry": {
              "type": "Point",
              "coordinates": [
                  5.583246123669657,
                  52.01759559866014
              ]
          }
      },
      {
          "type": "Feature",
          "properties": {
              "buurtcode": "BU03450200",
              "buurtnaam": "Engelenburg",
              "brtnaam_gemeente": "Engelenburg",
              "Fasering": "Middellange termijn wijk"
          },
          "geometry": {
              "type": "Point",
              "coordinates": [
                  5.561997499999996,
                  52.0197065
              ]
          }
      },
      {
          "type": "Feature",
          "properties": {
              "buurtcode": "BU03450201",
              "buurtnaam": "Het Ambacht",
              "brtnaam_gemeente": "Het Ambacht",
              "Fasering": "Bedrijventerrein"
          },
          "geometry": {
              "type": "Point",
              "coordinates": [
                  5.5560575,
                  52.0151975
              ]
          }
      },
      {
          "type": "Feature",
          "properties": {
              "buurtcode": "BU03450202",
              "buurtnaam": "Boslaan en omgeving",
              "brtnaam_gemeente": "Gezonken Hoek",
              "Fasering": "Middellange termijn wijk"
          },
          "geometry": {
              "type": "Point",
              "coordinates": [
                  5.5499093033386595,
                  52.01358429911874
              ]
          }
      },
      {
          "type": "Feature",
          "properties": {
              "buurtcode": "BU03450203",
              "buurtnaam": "Petenbos",
              "brtnaam_gemeente": "Petenbos",
              "Fasering": "Verkenningswijk"
          },
          "geometry": {
              "type": "Point",
              "coordinates": [
                  5.547829948550791,
                  52.007459331363926
              ]
          }
      },
      {
          "type": "Feature",
          "properties": {
              "buurtcode": "BU03450204",
              "buurtnaam": "Petenbos-Oost",
              "brtnaam_gemeente": "Petenbos-Oost",
              "Fasering": "Verkenningswijk"
          },
          "geometry": {
              "type": "Point",
              "coordinates": [
                  5.5544006598293425,
                  52.003928718215676
              ]
          }
      },
      {
          "type": "Feature",
          "properties": {
              "buurtcode": "BU03450205",
              "buurtnaam": "Nijverkamp",
              "brtnaam_gemeente": "Nijverkamp",
              "Fasering": "Bedrijventerrein"
          },
          "geometry": {
              "type": "Point",
              "coordinates": [
                  5.568847755008532,
                  52.007121958972306
              ]
          }
      },
      {
          "type": "Feature",
          "properties": {
              "buurtcode": "BU03450206",
              "buurtnaam": "De Groene Velden",
              "brtnaam_gemeente": "De Groene Velden",
              "Fasering": "Natuurlijk tempo (individuele oplossing)"
          },
          "geometry": {
              "type": "Point",
              "coordinates": [
                  5.568604479683937,
                  52.017828626107224
              ]
          }
      },
      {
          "type": "Feature",
          "properties": {
              "buurtcode": "BU03450207",
              "buurtnaam": "De Blauwe Hel",
              "brtnaam_gemeente": "De Blauwe Hel",
              "Fasering": "Natuurlijk tempo (individuele oplossing)"
          },
          "geometry": {
              "type": "Point",
              "coordinates": [
                  5.578561860937703,
                  52.011899721257215
              ]
          }
      },
      {
          "type": "Feature",
          "properties": {
              "buurtcode": "BU03450208",
              "buurtnaam": "Bezuiden de Middelbuurtseweg",
              "brtnaam_gemeente": "Hondzenelleboog",
              "Fasering": "Natuurlijk tempo (individuele oplossing)"
          },
          "geometry": {
              "type": "Point",
              "coordinates": [
                  5.563001500000001,
                  52.002525500000004
              ]
          }
      },
      {
          "type": "Feature",
          "properties": {
              "buurtcode": "BU03450300",
              "buurtnaam": "'t Goeie Spoor en omgeving",
              "brtnaam_gemeente": "Stationswijk",
              "Fasering": "Middellange termijn wijk"
          },
          "geometry": {
              "type": "Point",
              "coordinates": [
                  5.5470743571105325,
                  52.02339254157841
              ]
          }
      },
      {
          "type": "Feature",
          "properties": {
              "buurtcode": "BU03450301",
              "buurtnaam": "Franse Gat",
              "brtnaam_gemeente": "Franse Gat",
              "Fasering": "Verkenningswijk"
          },
          "geometry": {
              "type": "Point",
              "coordinates": [
                  5.542305300027902,
                  52.01848463327709
              ]
          }
      },
      {
          "type": "Feature",
          "properties": {
              "buurtcode": "BU03450302",
              "buurtnaam": "Salamander",
              "brtnaam_gemeente": "Salamander",
              "Fasering": "Natuurlijk tempo (individuele oplossing)"
          },
          "geometry": {
              "type": "Point",
              "coordinates": [
                  5.538634499999998,
                  52.0105535
              ]
          }
      },
      {
          "type": "Feature",
          "properties": {
              "buurtcode": "BU03450400",
              "buurtnaam": "Molenbrug",
              "brtnaam_gemeente": "Molenbrug",
              "Fasering": "Verkenningswijk"
          },
          "geometry": {
              "type": "Point",
              "coordinates": [
                  5.547079500000001,
                  52.0274735
              ]
          }
      },
      {
          "type": "Feature",
          "properties": {
              "buurtcode": "BU03450401",
              "buurtnaam": "'t Hoorntje",
              "brtnaam_gemeente": "'t Hoorntje",
              "Fasering": "Middellange termijn wijk"
          },
          "geometry": {
              "type": "Point",
              "coordinates": [
                  5.549167588722455,
                  52.033776396069655
              ]
          }
      },
      {
          "type": "Feature",
          "properties": {
              "buurtcode": "BU03450402",
              "buurtnaam": "De Pol",
              "brtnaam_gemeente": "De Pol",
              "Fasering": "Middellange termijn wijk"
          },
          "geometry": {
              "type": "Point",
              "coordinates": [
                  5.5583045,
                  52.033114
              ]
          }
      },
      {
          "type": "Feature",
          "properties": {
              "buurtcode": "BU03450403",
              "buurtnaam": "De Gelderse blom",
              "brtnaam_gemeente": "De Gelderse blom",
              "Fasering": "Middellange termijn wijk"
          },
          "geometry": {
              "type": "Point",
              "coordinates": [
                  5.554484999999998,
                  52.036729
              ]
          }
      },
      {
          "type": "Feature",
          "properties": {
              "buurtcode": "BU03450404",
              "buurtnaam": "De Compagnie",
              "brtnaam_gemeente": "De Compagnie",
              "Fasering": "Bedrijventerrein"
          },
          "geometry": {
              "type": "Point",
              "coordinates": [
                  5.560938191106009,
                  52.03963068239098
              ]
          }
      },
      {
          "type": "Feature",
          "properties": {
              "buurtcode": "BU03450405",
              "buurtnaam": "De Batterijen",
              "brtnaam_gemeente": "De Batterijen",
              "Fasering": "Bedrijventerrein"
          },
          "geometry": {
              "type": "Point",
              "coordinates": [
                  5.563287231784313,
                  52.04499524342141
              ]
          }
      },
      {
          "type": "Feature",
          "properties": {
              "buurtcode": "BU03450500",
              "buurtnaam": "Oudeveen en De Schans en omgeving",
              "brtnaam_gemeente": "Pioniersbuurt",
              "Fasering": "Middellange termijn wijk"
          },
          "geometry": {
              "type": "Point",
              "coordinates": [
                  5.540258405486917,
                  52.03351292088625
              ]
          }
      },
      {
          "type": "Feature",
          "properties": {
              "buurtcode": "BU03450501",
              "buurtnaam": "Componistenbuurt",
              "brtnaam_gemeente": "Componistenbuurt",
              "Fasering": "Middellange termijn wijk"
          },
          "geometry": {
              "type": "Point",
              "coordinates": [
                  5.531701079129714,
                  52.03595002028433
              ]
          }
      },
      {
          "type": "Feature",
          "properties": {
              "buurtcode": "BU03450502",
              "buurtnaam": "Vogelbuurt",
              "brtnaam_gemeente": "Vogelbuurt",
              "Fasering": "Middellange termijn wijk"
          },
          "geometry": {
              "type": "Point",
              "coordinates": [
                  5.531720351510635,
                  52.030121652213886
              ]
          }
      },
      {
          "type": "Feature",
          "properties": {
              "buurtcode": "BU03450503",
              "buurtnaam": "Schepenbuurt",
              "brtnaam_gemeente": "Schepenbuurt",
              "Fasering": "Middellange termijn wijk"
          },
          "geometry": {
              "type": "Point",
              "coordinates": [
                  5.532866570824825,
                  52.02193406656285
              ]
          }
      },
      {
          "type": "Feature",
          "properties": {
              "buurtcode": "BU03450504",
              "buurtnaam": "Dichtersbuurt",
              "brtnaam_gemeente": "Dichtersbuurt",
              "Fasering": "Middellange termijn wijk"
          },
          "geometry": {
              "type": "Point",
              "coordinates": [
                  5.524283499999997,
                  52.0250585
              ]
          }
      },
      {
          "type": "Feature",
          "properties": {
              "buurtcode": "BU03450505",
              "buurtnaam": "De Faktorij en De Vendel",
              "brtnaam_gemeente": "De Faktorij en De Vendel",
              "Fasering": "Bedrijventerrein"
          },
          "geometry": {
              "type": "Point",
              "coordinates": [
                  5.5437421530217765,
                  52.03987344543313
              ]
          }
      },
      {
          "type": "Feature",
          "properties": {
              "buurtcode": "BU03450506",
              "buurtnaam": "Fort Buurtsteeg",
              "brtnaam_gemeente": "Fort Buurtsteeg",
              "Fasering": "Natuurlijk tempo (individuele oplossing)"
          },
          "geometry": {
              "type": "Point",
              "coordinates": [
                  5.5487235,
                  52.045559
              ]
          }
      },
      {
          "type": "Feature",
          "properties": {
              "buurtcode": "BU03450507",
              "buurtnaam": "Bezuiden de Dijkstraat",
              "brtnaam_gemeente": "Bezuiden de Dijkstraat",
              "Fasering": "Natuurlijk tempo (individuele oplossing)"
          },
          "geometry": {
              "type": "Point",
              "coordinates": [
                  5.5204450000000005,
                  52.017936000000006
              ]
          }
      },
      {
          "type": "Feature",
          "properties": {
              "buurtcode": "BU03450105",
              "buurtnaam": "Veenendaal-Oost",
              "brtnaam_gemeente": "Groenpoort",
              "Fasering": "Verkenningswijk"
          },
          "geometry": {
              "type": "Point",
              "coordinates": [
                  5.584060499999999,
                  52.0307215
              ]
          }
      },
      {
          "type": "Feature",
          "properties": {
              "buurtcode": "BU03450105",
              "buurtnaam": "Veenendaal-Oost",
              "brtnaam_gemeente": "Buurtstede",
              "Fasering": "Verkenningswijk"
          },
          "geometry": {
              "type": "Point",
              "coordinates": [
                  5.583428502846056,
                  52.02375533771685
              ]
          }
      }
  ]
}